export const QUOTE_QUERY_KEYS = {
    quote: 'quote',
    simplifiedQuote: 'simplifiedQuote',
    quoteCalculations: 'quoteCalculations'
}

export const QUOTE_MUTATION_KEYS = {
    updateQuotePrice: 'updateQuotePrice'
}
